import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { UserContext } from '../../Context/UserContextProvider';

// styles
import styles from "./UserChats.module.css";

export default function UserChatCards({ chatData }) {
    const { userData } = useContext(UserContext);

    return (
        <>
            {chatData == "" ?
                <div className={`w-100 d-flex align-items-center justify-content-center ${styles.chat_title}`} style={{ minHeight: "397px" }}>
                    هنوز هیچ موردی برای نمایش وجود ندارد
                </div>
                :
                chatData?.map((data) => (
                    userData.id === data.senderId ?
                        <>
                            <div className={`w-100 d-flex align-items-center justify-content-between my-2 ${styles.card_container}`} dir='rtl'>
                                <div className='d-flex align-items-center justify-content-center'>
                                    <img className={`${styles.profile_img}`} src={`https://backdev.azrmelk.com/images/users/avatar/${data.recieverAvatar}`} alt="user-profile" />
                                    <h5 className={`pe-3 mb-0 ${styles.chat_title}`}> {data.recieverFullName} </h5>
                                </div>
                                <Link to={{
                                    pathname: `/user-chat-detail/${data.id}`,
                                    state: data
                                }} className='ms-3'>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.15533 0.96967C6.44822 1.26256 6.44822 1.73744 6.15533 2.03033L2.93566 5.25H10.875C11.2892 5.25 11.625 5.58579 11.625 6C11.625 6.41421 11.2892 6.75 10.875 6.75H2.93566L6.15533 9.96967C6.44822 10.2626 6.44822 10.7374 6.15533 11.0303C5.86244 11.3232 5.38756 11.3232 5.09467 11.0303L0.59467 6.53033C0.301777 6.23744 0.301777 5.76256 0.59467 5.46967L5.09467 0.96967C5.38756 0.676777 5.86244 0.676777 6.15533 0.96967Z" fill="#21409A" />
                                    </svg>
                                </Link>
                            </div>
                        </>
                        :
                        <>
                            <div className={`w-100 d-flex align-items-center justify-content-between my-2 ${styles.card_container}`} dir='rtl'>
                                <div className='d-flex align-items-center justify-content-center'>
                                    <img className={`${styles.profile_img}`} src={`https://backdev.azrmelk.com/images/users/avatar/${data.senderAvatar}`} alt="user-profile" />
                                    <h5 className={`pe-3 mb-0 ${styles.chat_title}`}> {data.senderFullName} </h5>
                                </div>
                                <Link to={{
                                    pathname: `/user-chat-detail/${data.id}`,
                                    state: data
                                }} className='ms-3'>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.15533 0.96967C6.44822 1.26256 6.44822 1.73744 6.15533 2.03033L2.93566 5.25H10.875C11.2892 5.25 11.625 5.58579 11.625 6C11.625 6.41421 11.2892 6.75 10.875 6.75H2.93566L6.15533 9.96967C6.44822 10.2626 6.44822 10.7374 6.15533 11.0303C5.86244 11.3232 5.38756 11.3232 5.09467 11.0303L0.59467 6.53033C0.301777 6.23744 0.301777 5.76256 0.59467 5.46967L5.09467 0.96967C5.38756 0.676777 5.86244 0.676777 6.15533 0.96967Z" fill="#21409A" />
                                    </svg>
                                </Link>
                                {/* <Link to={{
                                    pathname: `/user-managment-chat-detail/${data.id}`,
                                    state: data
                                }} className={`me-auto ${styles.link_icon_text}`}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.15533 0.96967C6.44822 1.26256 6.44822 1.73744 6.15533 2.03033L2.93566 5.25H10.875C11.2892 5.25 11.625 5.58579 11.625 6C11.625 6.41421 11.2892 6.75 10.875 6.75H2.93566L6.15533 9.96967C6.44822 10.2626 6.44822 10.7374 6.15533 11.0303C5.86244 11.3232 5.38756 11.3232 5.09467 11.0303L0.59467 6.53033C0.301777 6.23744 0.301777 5.76256 0.59467 5.46967L5.09467 0.96967C5.38756 0.676777 5.86244 0.676777 6.15533 0.96967Z" fill="#21409A" />
                                    </svg>
                                </Link> */}
                            </div>
                        </>
                    // <div className={`w-100 d-flex align-items-center justify-content-between my-2 ${styles.card_container}`} dir='rtl'>
                    //     <div className='d-flex align-items-center justify-content-center'>
                    //         <img className={`${styles.profile_img}`} src={`https://backdev.azrmelk.com/images/users/avatar/${item.senderAvatar}`} alt="user-profile" />
                    //         <h5 className={`pe-3 mb-0 ${styles.chat_title}`}> {item.senderFullName} </h5>
                    //     </div>
                    //     <Link to={{
                    //         pathname: `/user-chat-detail/${item.id}`,
                    //         state: item
                    //     }} className='ms-3'>
                    // <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //     <path fill-rule="evenodd" clip-rule="evenodd" d="M6.15533 0.96967C6.44822 1.26256 6.44822 1.73744 6.15533 2.03033L2.93566 5.25H10.875C11.2892 5.25 11.625 5.58579 11.625 6C11.625 6.41421 11.2892 6.75 10.875 6.75H2.93566L6.15533 9.96967C6.44822 10.2626 6.44822 10.7374 6.15533 11.0303C5.86244 11.3232 5.38756 11.3232 5.09467 11.0303L0.59467 6.53033C0.301777 6.23744 0.301777 5.76256 0.59467 5.46967L5.09467 0.96967C5.38756 0.676777 5.86244 0.676777 6.15533 0.96967Z" fill="#21409A" />
                    // </svg>
                    //     </Link>
                    // </div>
                ))
            }
        </>
    )

}
